import { useMemo as d } from "react";
import { m as c, p as u } from "./utils.BA8Gszn5.js";
const n = {
  size: {
    prefix: "sizes",
    default: "sizesdefault",
    valueSelector: "default"
  },
  style: {
    prefix: "styles",
    default: "stylesdefault",
    valueSelector: "default"
  },
  theme: {
    prefix: "themes",
    default: "themesdefault",
    valueSelector: "default"
  }
}, v = ({
  styles: t,
  defaultClass: r,
  extendedStyles: s,
  selectors: f
}) => d(() => {
  let e = [];
  if (e.push(t[r]), f) {
    const a = c(
      n,
      f
    ), o = new Map(Object.entries(t));
    for (const l of Object.values(a)) {
      const i = o.get(`${l.prefix}${l.valueSelector}`) || (l.default ? t[l.default] : null);
      e.push(i);
    }
  }
  return s && (e = e.concat(s.filter(u))), e.filter(u).join(" ").trim();
}, [t, r, f, s]);
export {
  v
};
//# sourceMappingURL=usePresentationClassWithSelectors.tBtkTeh8.js.map
